<div class="collapse-sidebar {{ type }} {{ background }}">
  <div class="sidebar-toggle" [class.d-none]="type === 'back'">
    <h1 class="h3-bold m-0 primary-80">
      {{ title }}
      <!-- <span class="key-btn primary-70 h4-reg">⌘H</span> -->
    </h1>
    @if (icon) {
      <app-action-btn
        [active]="false"
        [IconType]="icon"
        (click)="handleClose($event)"></app-action-btn>
    }
  </div>
  @if (type === 'back') {
    <div class="sidebar-toggle">
      <h1 class="h3-bold m-0 primary-80 d-flex align-items-center spacing-16">
        <app-action-btn
          [active]="false"
          IconType="{{ icon }}"
          (click)="handleClose($event)"></app-action-btn
        >{{ title }}
      </h1>
    </div>
  }
</div>
